module.exports = __webpack_public_path__ + "static/img/image063.077b7f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image063.png
// module id = rTi+
// module chunks = 1